import React, { useState } from 'react';

import './style.scss'
import '../styles/calendar-styles.css'


const LandingCalendar = () => { 
    /*--------------------------------------------*/
   
    const weekdays_abbr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    var emptyDayKey = 0;

    const time = new Date();
    var [usedTime, setUsedTime] = useState(time);
    var [isMonthChanged, setisMonthChanged] = useState(months[usedTime.getMonth()] + ' ' + usedTime.getFullYear());
    

    const get_time = () => {
        return usedTime;
    }

    var [clickedDay, setClickedDay] = useState('');
    

    const setTime = (offset) => {
        setUsedTime(
            usedTime = new Date(get_time().getFullYear(), get_time().getMonth()+offset)
        );
        setisMonthChanged (isMonthChanged = months[usedTime.getMonth()] + ' ' + usedTime.getFullYear());
        setClickedDay (clickedDay = 0);
    }

    let total_days_in_month = new Date(get_time().getFullYear(), get_time().getMonth() + 1, 0).getDate();
    let weekday_of_1st_of_month = new Date(get_time().getFullYear(), get_time().getMonth(),1).getDay();

    const generateEmptyDays = () => {
        let daysArr = new Array([]);
        let daysGen = 1;
        while (daysGen <= weekday_of_1st_of_month) {
            daysArr.push(' ');
            daysGen ++;
        }

        return daysArr;
    }

    const generateDaysArr = () => {
        let daysArr = new Array([]);
        let daysGen = 1;
        while (daysGen <= total_days_in_month) {
            daysArr.push(daysGen);
            daysGen ++;
        }

        return daysArr;
    }


    const handleDayClick = (day) => {
        const todayCell = document.getElementById('calendarDayId'+get_time().getDate());
        todayCell.classList.remove('calendarDayClicked');
        setClickedDay(clickedDay = day);
        document.getElementsByClassName('hiddenInput')[0].value = get_time().getMonth()+1 + '/' + day + '/' + get_time().getFullYear();

        document.getElementsByClassName('day')[0].innerHTML = day;
        document.getElementsByClassName('month')[0].innerHTML = monthNames[get_time().getMonth()]; 
        document.getElementsByClassName('year')[0].innerHTML = get_time().getFullYear();  
    }

    
    
    /*--------------------------------------------*/
    

    return (
        <section>
            <div className='calendarContainer'>
                <div className='calendarMonthHeaderWrapper'>
                    <div className='calendarMonthArrow' role="button" tabIndex={0} onKeyDown={() => setTime(-1)}  onClick={() => setTime(-1)}> &lt; </div>
                    <div className='calendarMonthHeaderText'>{isMonthChanged}</div>
                    <div className='calendarMonthArrow' role="button" tabIndex={0} onKeyDown={() => setTime(+1)} onClick={() => setTime(+1)}> &gt; </div>
                </div>
                <div className='calendarWeekWrapper'>
                {weekdays_abbr.map((weekday) => {
                    return (
                        <div key={weekday} className='calendarWeekDay'>{weekday}</div>
                    );
                })}
                </div>
                <div className='calendarDaysGrid'>
                    <div className='disableSaturday'>

                    </div>
                {generateEmptyDays().map((day) => {
                    emptyDayKey++;
                    return (
                        <div key={emptyDayKey} className='calendarDayEmpty'>{day}</div>
                    );
                })}
                    {
                    generateDaysArr().map((day) => {
                    return (
                        <div key={'calendarDayId'+day} id={'calendarDayId'+day} className={clickedDay === day ? 'calendarDay calendarDayClicked' : 'calendarDay'} onClick={() => handleDayClick(day)} role="button" tabIndex={0} onKeyDown={() => handleDayClick(day)}>{day}</div>
                    );
                    
                })}
                </div>
            </div>
        </section>
    );
};

export default LandingCalendar;